import React from 'react'
import axios from 'axios'
import classnames from 'classnames'
import { fragContact } from '../utils/fragments'
import { mapContact, mapMetaData } from '../utils/mapper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import styles from '../styles/site'
import '../styles/transitions.css'

import TextGradient from '../components/gradient'
import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Quote from '../components/quote'
import Footer from '../components/footer'

import { API } from '../utils/constants'

class ContactPage extends React.Component {
  state = {
    formdata: {
      name: null,
      email: null,
      mobile: null,
      msg: null,
    },
  }

  onChange = e => {
    let formdata = this.state.formdata
    formdata[e.target.id] = e.target.value
    this.setState({ formdata: formdata })
  }

  submitForm = () => {
    let formdata = this.state.formdata

    axios
      .post(API.enquiry, {
        mtype: 'Enquiry',
        template: 'enquiry',
        name: formdata.name,
        email: formdata.email,
        mobile: formdata.mobile,
        msg: formdata.msg,
      })
      .then(response => {
        toast.success('Your enquiry has been sent, thanks.')
      })
  }

  render() {
    const { classes } = this.props
    const metadata = mapMetaData(this.props.data.contact)
    const contact = mapContact(this.props.data.contact)
    const { formdata } = this.state
    return (
      <div>
        <ToastContainer />
        <MetaData data={metadata} />
        <Banner
          uid="contact"
          title={contact.title}
          subtitle={contact.subtitle}
          background={contact.image}
        />
        {contact.contents.map((item, index) => {
          switch (item.type) {
            case 'channels': {
              return <Channels key={index} item={item} />
            }
            case 'office': {
              return <Offices key={index} item={item} />
            }
            case 'text_block': {
              return (
                <Form
                  key={index}
                  item={item}
                  onChange={this.onChange}
                  formdata={formdata}
                  submitForm={this.submitForm}
                />
              )
            }
            // case 'promotion': {
            //   return <Clients key={index} item={item} />
            // }
          }
        })}
        <Footer policies={this.props.data.policies.edges}/>
      </div>
    )
  }
}

const Channels = withStyles(styles)(props => {
  const { classes, item } = props
  return (
    <div className={classes.channels}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="display1" className={classes.channelTitle}>
                <TextGradient
                  text={item.heading.text}
                  fromColor="#8645B3"
                  toColor="#89DEF4"
                  direction="left"
                />
              </Typography>
              <div className={classes.channelList}>
                {item.channels.map(data => {
                  return <Channel channel={data} />
                })}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Channel = withStyles(styles)(data => {
  const { classes, channel } = data
  return (
    <div className={classes.channelListItem}>
      <Typography variant="title">{channel.channel.text}</Typography>
      <Typography>
        <a href={`${channel.type}:${channel.contact.text}`} className={classes.contactLink}>{channel.contact.text}</a>
      </Typography>
    </div>
  )
})

const Form = withStyles(styles)(props => {
  const { classes, item, onChange, formdata, submitForm } = props
  return (
    <div className={classes.contactForm}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="display1" className={classes.channelTitle}>
                <TextGradient
                  text={item.heading.text}
                  fromColor="#8645B3"
                  toColor="#89DEF4"
                  direction="left"
                />
              </Typography>
              <Typography>{item.content.text}</Typography>
              <form noValidate autoComplete="off">
                <TextField
                  id="name"
                  label="Name"
                  className={classes.contactFormField}
                  fullWidth={true}
                  margin="normal"
                  value={formdata.name}
                  onChange={e => onChange(e)}
                />
                <TextField
                  id="email"
                  label="Email"
                  className={classes.contactFormField}
                  fullWidth={true}
                  margin="normal"
                  value={formdata.email}
                  onChange={e => onChange(e)}
                />
                <TextField
                  id="mobile"
                  label="Mobile"
                  className={classes.contactFormField}
                  fullWidth={true}
                  margin="normal"
                  value={formdata.mobile}
                  onChange={e => onChange(e)}
                />
                <TextField
                  id="msg"
                  label="Message"
                  multiline={true}
                  rows={3}
                  fullWidth={true}
                  className={classes.contactFormField}
                  margin="normal"
                  value={formdata.msg}
                  onChange={e => onChange(e)}
                />
                <div>
                  <Button
                    size={'small'}
                    variant={'raised'}
                    className={classes.contactFormSubmit}
                    onClick={() => submitForm()}
                  >
                    Post form
                  </Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Offices = withStyles(styles)(props => {
  const { classes, item } = props
  return (
    <div className={classnames(classes.offices, 'contactForm')}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="display1" className={classes.officeTitle}>
                <TextGradient
                  text={item.heading.text}
                  fromColor="#efefef"
                  toColor="#fff"
                  direction="left"
                />
              </Typography>
              <Grid
                container
                spacing={40}
                alignItems={'flex-start'}
                direction={'row'}
                justify={'flex-start'}
              >
                {item.contents.map(data => {
                  return (
                    <Grid item xs={12} md={6}>
                      <div
                        className={classnames(
                          classes[`officeAddressTheme_${data.theme}`]
                        )}
                      >
                        <Typography variant="title" gutterBottom={true}>
                          {data.location.text}
                        </Typography>
                        {/* <Typography variant="subheading">
                          <a href={`tel:${data.telephone.text}`} className={classnames(classes.contactLink, classes.contactLinkWhite)}>0121 393 4700</a>
                        </Typography> */}
                        <Typography>
                          <div className={classes.officeAddress}>
                            {data.address.text.split(',').map(line => {
                              return <div>{line}</div>
                            })}
                          </div>
                        </Typography>
                      </div>
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(ContactPage)

export const query = graphql`
  query contactQuery {
    contact: prismicCtContact {
      ...contact
    }
    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {

              text
            }


          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js